import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error }
  }

  componentDidCatch (error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
    if (window.DD_RUM && typeof window.DD_RUM.addError === 'function') {
      window.DD_RUM.addError(error, { source: 'ErrorBoundary', ...errorInfo })
    }
  }

  handleReload = () => {
    window.location.reload()
  }

  render () {
    if (this.state.hasError) {
      return (
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          minHeight='100vh'
          p={3}
          textAlign='center'
        >
          <Typography variant='h5' gutterBottom>
            Something went wrong
          </Typography>
          <Typography variant='body1' color='textSecondary' gutterBottom>
            An unexpected error occurred. Please try reloading the page.
          </Typography>
          <Button
            variant='contained'
            color='primary'
            onClick={this.handleReload}
            sx={{ mt: 2 }}
          >
            Reload Page
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
